import { InjectionToken } from '@angular/core';

export interface SupabaseConfig {
    supabaseUrl: string;
    supabaseKey: string;
}

export const SUPABASE_CONFIG = new InjectionToken<SupabaseConfig>('SUPABASE_CONFIG');
